import React, { useState } from "react";
import { Typography, Button, Box, Link, Fade, Grid } from "@mui/material";
import { Facebook, Instagram, YouTube } from "@mui/icons-material";
import { member } from "../../lists/250621/memberText";
import { setList } from "../../lists/250621/setListText";
import SectionWrapper from "./components/SectionWrapper";
import MembersSection from "./components/MembersSection";
import SetlistSection from "./components/SetlistSection";
import MemberDrawer from "./components/MemberDrawer";
import LyricsDrawer from "./components/LyricsDrawer";
import LiveInfoDrawer from "./components/LiveInfoDrawer";
import HeroImage from "./components/HeroImage";

const handleSurvey = () => {
  window.open("https://forms.gle/owyLY4qKNWFjGfa7A", "_blank");
};

const handleStore = () => {
  window.open(
    "https://yukino-815.stores.jp/items/67e391089e24a1b6d5285ecc",
    "_blank"
  );
};

const Live250621 = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [lyricDialogOpen, setLyricDialogOpen] = useState(false);
  const [selectedSong, setSelectedSong] = useState(null);
  const [liveDialogOpen, setLiveDialogOpen] = useState(false);
  const [heroImageLoaded, setHeroImageLoaded] = useState(false);

  const handleMemberOpen = (m: any) => setSelectedMember(m);
  const handleMemberClose = () => setSelectedMember(null);

  const handleLyricOpen = (song: any) => {
    setSelectedSong(song);
    setLyricDialogOpen(true);
  };

  const handleLyricClose = () => setLyricDialogOpen(false);

  const handleLiveDialogOpen = () => setLiveDialogOpen(true);
  const handleLiveDialogClose = () => setLiveDialogOpen(false);

  // 重要な画像をプリロード
  React.useEffect(() => {
    const preloadImages = [
      "/images/250621/Cover.png",
      ...member.map(m => m.img)
    ];
    
    preloadImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = src;
      document.head.appendChild(link);
    });
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", fontFamily: "serif" }}>
      <Fade in={heroImageLoaded} timeout={1000}>
        <Box>
          <HeroImage 
            src="/images/250621/Cover.png"
            alt="雨宿りの白昼夢"
            onLoad={() => setHeroImageLoaded(true)}
          />

          <SectionWrapper title="ごあいさつ" bgcolor="#e5ebe9">
            <Typography
              variant="body1"
              align="justify"
              sx={{ color: "#2c3f42" }}
            >
              本日はお越しいただきありがとうございます！
              <br />
              皆様に支えられながら1歩1歩と進んで、歌い始めてから3年目、大きいライブは3回目となりました。
              <br />
              いつも本当にありがとうございます。
              <br /> <br />
              今回は、「雨宿りの白昼夢」ということで、夢のようなゆったりとした時間をお過ごしいただけたら幸いです。
              …本当に雨宿りにならず、お天気になって良かったですね笑
              <br /> <br />
              ではでは、 <br />
              お時間の許す限り、楽しんでいってください！
            </Typography>
          </SectionWrapper>
        </Box>
      </Fade>

      {/* 画像読み込み完了後に表示される下部セクション */}
      <Fade in={heroImageLoaded} timeout={800} style={{ transitionDelay: '200ms' }}>
        <Box>
          <SectionWrapper title="メンバー紹介" bgcolor="#f1f5f4">
            <MembersSection members={member} onMemberClick={handleMemberOpen} />
          </SectionWrapper>

          <SectionWrapper title="セットリスト" bgcolor="#e9f0ee">
            <SetlistSection 
              setList={setList} 
              onLyricOpen={handleLyricOpen}
              drawerOpen={lyricDialogOpen}
            />
          </SectionWrapper>

          <SectionWrapper title="おわりに" bgcolor="#f1f5f4">
            <Typography
              variant="body1"
              align="justify"
              mb={2}
              sx={{ color: "#2c3f42" }}
            >
              最後までご覧いただきありがとうございます！
              <br />
              活動の幅を広げつつ、これからも静かな音楽を届けていこうと思っていますので、ぜひ見守っていただけたら嬉しいです。
              <br />
              最後に、下記より感想をお待ちしております。
              お手隙の時にご回答いただけますと幸いです。
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={handleSurvey}
                sx={{ bgcolor: "#b4bdbb", color: "#2c3f42" }}
              >
                回答する
              </Button>
            </Box>
          </SectionWrapper>

          <SectionWrapper title="お知らせ" bgcolor="#e5ebe9">
            <Typography variant="body1" sx={{ color: "#2c3f42" }}>
              ▼次回のライブ予定
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#2c3f42",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={handleLiveDialogOpen}
            >
              2025.07.15(火) 20:00〜 日暮里Bar Porto
            </Typography>

            <Typography variant="body1" sx={{ color: "#2c3f42", mt: 2 }}>
              ▼今回のライブのアーカイブ
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#2c3f42",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={handleStore}
            >
              詳細ページこちら
            </Typography>
          </SectionWrapper>
        </Box>
      </Fade>

      <MemberDrawer
        open={Boolean(selectedMember)}
        handleClose={handleMemberClose}
        member={selectedMember}
      />
      
      <LyricsDrawer
        open={lyricDialogOpen}
        handleClose={handleLyricClose}
        song={selectedSong}
      />

      <LiveInfoDrawer
        open={liveDialogOpen}
        handleClose={handleLiveDialogClose}
      />

      <Box component="footer" sx={{ mt: 6, pb: 4 }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item>
            <Link
              href="https://m.facebook.com/yukino.yoshida.315"
              target="_blank"
            >
              <Facebook fontSize="large" sx={{ color: "#b4bdbb" }} />
            </Link>
          </Grid>
          <Grid item>
            <Link href="https://www.instagram.com/non.__cmr" target="_blank">
              <Instagram fontSize="large" sx={{ color: "#b4bdbb" }} />
            </Link>
          </Grid>
          <Grid item>
            <Link
              href="https://youtube.com/@non.169?si=44sM1ZXJCoOEldQ3"
              target="_blank"
            >
              <YouTube fontSize="large" sx={{ color: "#b4bdbb" }} />
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Live250621;